import * as actionTypes from 'src/store/actions';

const initialState = {
  message: null,
  variant: 'default',
  open: false,
  loginError: ''
};

const alertReducer = (state = initialState, action = { type: '' }) => {
  switch (action.type) {
    case actionTypes.ALERT_INFO:
    case actionTypes.ALERT_WARNING:
    case actionTypes.ALERT_ERROR:
    case actionTypes.ALERT_SUCCESS:
      return {
        message: action.message,
        variant: action.variant,
        open: true
      };

    case actionTypes.CLOSE:
      return {
        ...state,
        open: false
      };
    case 'SET_LOGIN_ISSUE':
      return {
        ...state,
        loginError: action.payload
      };
    default:
      return state;
  }
};

export default alertReducer;
